import ActionInput from '../../../components/common/actioninput/ActionInputField';
import DeleteIcon from '@mui/icons-material/Delete';
import './ApprovalCard.css'
import './index.css'
import ButtonComponent from '../../../components/common/button/Button';
import { IconButton } from '@mui/material';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { useDispatch, useSelector } from "react-redux";
import { Loader } from '../../../components/common/Loader';
const WorkFlowAddExtraApproversModalContent = ({ key, allNamesFilled, disableAddApprovalButton, allUsers, rows, handleChangeApprover, addApprover, onHandleDeleteIcon, className, minApprovalLevels }) => {
  const stateSelector = useSelector((state) => state);
  return (
    (stateSelector?.TotalApproverListSlice?.loading) ?
      <div className={className || 'sendForApproval_cls'} style={{ width: 500 }}>
        <Loader />
      </div>
      :
      <div className={className || 'sendForApproval_cls'}>
        <div className='approval-wrapper'>
          <div className='approver-header'>
            <div className='smallWidth-column'>Level</div>
            <div className='largeWidth-column'>Approver Name</div>
            <div className='largeWidth-column'>Email ID </div>
            <div className='deleteIcon-column'><p></p></div>
          </div>
          {rows?.map((item, index) => (
            <div className='sendForApprover-container' key={index}>
              <div style={{ paddingTop: "16px", paddingBottom: "10px", paddingLeft: "10px", display: 'flex', alignItems: 'center' }} className='smallWidth-column'>{index + 1}</div>
              {item?.isNotAddApprovers === true ?
                <div style={{ paddingTop: "10px", paddingBottom: "10px", }} className='largeWidth-column'>
                  <Autocomplete
                    key={key}
                    className="custom-autocomplete"
                    options={allUsers}
                    renderInput={(params) => <TextField {...params}
                      InputLabelProps={{ shrink: false }}
                      placeholder='Search Approver'

                    />}
                    onChange={(event, value) => handleChangeApprover(index, event, value)}
                    style={{ height: 40, maxWidth: 220 }}
                    value={item?.name || null}
                    disabled={true}
                  />
                </div>
                :
                <div style={{ paddingTop: "10px", paddingBottom: "10px", }} className='largeWidth-column'>
                  <Autocomplete
                    key={key}
                    className="custom-autocomplete"
                    freeSolo
                    options={allUsers}
                    getOptionLabel={(option) => option?.name}
                    getOptionDisabled={(option) =>
                      rows.some(user => user?.email === option?.email)
                    }
                    renderInput={(params) => <TextField {...params}
                      // label="Search"
                      InputLabelProps={{ shrink: false }}
                      placeholder='Search Approver'

                    />}
                    onChange={(event, value) => handleChangeApprover(index, event, value)}
                    style={{ height: 40, maxWidth: 220 }}
                    value={allUsers?.find(obj => obj.name === item.name) || null}
                  // disabled={(rows?.length - 1) !== index}
                  />
                </div>
              }


              <div className='largeWidth-column' style={{ paddingTop: "10px", paddingBottom: "10px" }}>

                <ActionInput
                  value={item?.email}
                  props={{ height: "40px", maxWidth: "220px", }}
                  placeholder='Email'
                  disabled={true}
                />
              </div>
              <div className='deleteIcon-column' style={{ paddingTop: "10px", textAlign: "right" }}>
                {item?.isNotAddApprovers === true ? <></>
                  :
                  <IconButton>
                    {rows?.length > minApprovalLevels && <DeleteIcon onClick={() => onHandleDeleteIcon(index)} />}
                  </IconButton>
                }
              </div>
            </div>
          ))}
        </div>
        {rows?.length < 3 && <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '40px', marginTop: "15px" }}>
          <ButtonComponent
            maxWidth="170px"
            label="Add Approver"
            type="primary"
            disabled={!allNamesFilled}
            onClick={addApprover}
          />
        </div>}
      </div>
  )
}

const WorkFlowAddExtraApproversModalFooter = ({ disableSubmitButton, submitLabel, callAddApproversAPI, minApprovalLevels }) => {

  return (
    <div className='footer-btn-wrapper'>
      <ButtonComponent
        maxWidth="170px"
        label={submitLabel || "Submit"}
        bgColor="black"
        color="white"
        onClick={callAddApproversAPI}
        disabled={disableSubmitButton || minApprovalLevels === 3}
      />
    </div>
  );
};

export { WorkFlowAddExtraApproversModalContent, WorkFlowAddExtraApproversModalFooter }